import React from 'react'
import { StylesSpinnerProps, Wrapper } from './styles'

const Spinner: React.FC<StylesSpinnerProps> = ({ size }) => {
  return <Wrapper size={size}></Wrapper>
}

export default Spinner
